<div class="myEditor">
  <i-richedit #document_editor [lang]="lang" [options]="{ readOnly: true }" [showMergeFields]="true"
    [mergeFields]="mergeFields()" [printable]="allowPrint" [downloadable]="allowDownload"
    [exportable]="allowDownload"></i-richedit>
</div>